import { AxiosError, AxiosResponse } from 'axios';
import { Dispatch } from 'redux';
import { AppThunk } from 'store';

import { IPost } from '../../entities/post.entity';
import { CmsApi } from '../api/cms.api';
import {
  fetchCms,
  fetchCmsFailed,
  fetchCmsSucceeded,
} from '../slices/cms.slice';

export const updateCmsThunk = (
  id: string,
  values: Partial<IPost>,
  onError: (err?: AxiosError) => void,
): AppThunk<Promise<any>> => async (dispatch: Dispatch<any>) => {
  let response: AxiosResponse = null;
  dispatch(fetchCms({ key: id }));
  try {
    response = await CmsApi.updatePost(id, values);

    dispatch(
      fetchCmsSucceeded({
        list: { [id]: response.data },
      }),
    );
    onError();
  } catch (err) {
    const { name, response: responseError, stack, isAxiosError } = err;

    const error = {
      isAxiosError,
      message: responseError?.data?.message,
      name,
      code: responseError?.data?.statusCode,
      stack,
      config: {},
      toJSON: null,
    };
    // - Fetch failed, set error
    dispatch(
      fetchCmsFailed({
        key: id,
        error,
      }),
    );
    onError(error);
    throw error;
  }
};
